export const getFieldValueFromDataItemRecursively = (dataItem: any, field: string) => {
  const fieldArr = field.split(".");
  return fieldArr.reduce(
    (result, key) => {
      return result ? result[key] : result;
    },
    { ...dataItem }
  );
}